import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { DATA_ACCESS_TICKETS_FARES_FEATURE_KEY, reducers } from './reducers';
import { FareSelectorEffects } from './effects/fare-selectors';
import { FaresEffects } from './effects/fares';

@NgModule({
  imports: [
    StoreModule.forFeature(DATA_ACCESS_TICKETS_FARES_FEATURE_KEY, reducers),
    EffectsModule.forFeature([FareSelectorEffects, FaresEffects]),
  ],
})
export class TicketsAndFaresStoreModule {}
